var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"wrapper"},[_c('font-awesome-icon',{attrs:{"icon":[_vm.prefix, _vm.iconName],"size":_vm.size,"fixed-width":_vm.fw}}),(_vm.layer)?_c('span',{staticClass:"layer",class:`badge badge-${_vm.layer.color || 'black'}`},[_vm._v(" "+_vm._s(_vm.layer.value)+" ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }